import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const stopsApiRoutes = {
    list: apiBusSchedBaseURL + "stops/",
};

export class StopAPI {
    static list(networkEdition) {
        const url = new URL(`${networkEdition}`, stopsApiRoutes.list);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }
}